import type { EntityRecordResponse } from "@btnet/services-btnet/handlers/models/entityRecordResponse";
import { EntityType } from "@btnet/services-btnet/handlers/models/entityType";
import type { JobEntityRecordResponse } from "@btnet/services-btnet/handlers/models/jobEntityRecordResponse";
import type { SpecificationResponse } from "@btnet/services-btnet/handlers/models/specificationResponse";

/**
 * Converts a SpecificationResponse to an EntityRecordResponse
 * for use with EntityLinkSelector cache updates.
 */
export function toEntityRecord(spec: SpecificationResponse): EntityRecordResponse {
    const jobRecord: JobEntityRecordResponse = {
        id: spec.externalId,
        title: spec.title ?? "",
        entityId: spec.id,
        entityType: EntityType.Specification,
        organizationId: spec.builderId,
        jobId: spec.jobId,
        status: spec.status,
        isDeleted: false,
        entityRecordResponseType: "job",
    };
    return jobRecord;
}
